'use client';

import { createContext, ReactNode, useContext, useState } from 'react';

interface PageTitleContextType {
  pageTitle: string;
  secondaryTitle: string | null;
  setPageTitle: (title: string, secondaryTitle?: string | null) => void;
}

// Default context value
const defaultPageTitleContext: PageTitleContextType = {
  pageTitle: 'Sway',
  secondaryTitle: null,
  setPageTitle: () => {},
};

// Create context
const PageTitleContext = createContext<PageTitleContextType>(
  defaultPageTitleContext,
);

// Context provider component
export function PageTitleProvider({
  children,
  initialTitle = 'Sway',
  initialSecondaryTitle = null,
}: {
  children: ReactNode;
  initialTitle?: string;
  initialSecondaryTitle?: string | null;
}) {
  const [pageTitle, setPageTitle] = useState<string>(initialTitle);
  const [secondaryTitle, setSecondaryTitle] = useState<string | null>(
    initialSecondaryTitle,
  );

  const handleSetPageTitle = (
    title: string,
    newSecondaryTitle: string | null = null,
  ) => {
    setPageTitle(title);
    setSecondaryTitle(newSecondaryTitle);
  };

  return (
    <PageTitleContext.Provider
      value={{
        pageTitle,
        secondaryTitle,
        setPageTitle: handleSetPageTitle,
      }}
    >
      {children}
    </PageTitleContext.Provider>
  );
}

// Hook for consuming context
export function usePageTitle() {
  return useContext(PageTitleContext);
}
